import React, { useState, useEffect, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { timesheetApi } from "../../services";
import { Fieldset } from "primereact/fieldset";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import moment from "moment";

const ApprovedTeamTimesheet = ({ userData }) => {
  const dt = useRef(null);
  const [approvedTeamTimesheet, setApproveTeamTimesheet] = useState([]);
  const [approvedDialog, setApprovedDialog] = useState(false);
  const [currentApprovedRow, setCurrentApprovedRow] = useState({});
  const [dateRange, setDateRange] = useState([]);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      fetchApproveTeamTimesheet();
      count++;
    }
  }, [userData]);

  const dateRangeCalendar = (e) => {
    setDateRange(e.value);
    let param = {};
    param.userId = userData.id;
    param.status = "APPROVED";
    if (e.value[1]) {
      param.startDate = moment(e.value[0]).format("DD-MM-YYYY");
      param.endDate = moment(e.value[1]).format("DD-MM-YYYY");
      timesheetApi.getApprovedTeamTimesheet(param).then((resp) => {
        try {
          setApproveTeamTimesheet(resp.data.data);
        } catch (error) {
          // Error handle
        }
      });
    }
    if (e.value[1]) {
      document.getElementsByClassName("p-datepicker")[0].style.display = "none";
    }
  };

  const projectListBodyTemplate = (rowData) => {
    let proName = [];
    rowData.timesheetProjects.map((el) => {
      proName.push(el.projectDetails.title);
    });
    let proNameUnique = Array.from(new Set(proName));
    return <p>{proNameUnique.join(", ")}</p>;
  };

  const projectBodyTemplate = (rowData) => {
    return rowData.projectDetails ? rowData.projectDetails.title : "";
  };

  const ChargeableOrNot = (el) => {
    return el?.isBillable ? <span style={{ color: 'green' }}>Chargeable</span> : <span style={{ color: 'red' }}>Non Chargeable</span>;
  };

  const approvedDialogCall = (rowData) => {
    setCurrentApprovedRow(rowData);
    setApprovedDialog(true);
  }

  const approvedActionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" type="button" className="p-button-rounded p-button-secondary" aria-label="View" tooltip="View Timesheet" tooltipOptions={{ position: "top" }} onClick={() => approvedDialogCall(rowData)} />
      </React.Fragment>
    );
  };

  const categoryBodyTemplate = (rowData) => {
    return rowData.categories ? rowData.categories.title : "";
  }
  const activityBodyTemplate = (rowData) => {
    return rowData.activities ? rowData.activities.title : "";
  }

  const hoursRoundOffTemplate = (item) => {
    return item.hours?.toFixed(2);
  };
  const rowClassPopup = (rowData) => {
    let row = rowData.timesheetProjects.map((item) => item.categories.title);
    if (row.includes('Leave/PH')) {
      return {
        'row-accessories-leave': row
      }
    }
  }

  const ApprovedManagerViewTemplate = () => {
    return (
      <div className="orders-subtable">
        <Dialog className="review-timesheet-pop-up-dialog custom_popup" header={"View Approved Timesheet (" + currentApprovedRow?.date + ")"} visible={approvedDialog} onHide={() => setApprovedDialog(false)} >
          <Fieldset>
            <DataTable columnResizeMode="fit" scrollable="horizontal" stripedRows value={currentApprovedRow?.timesheetProjects} responsiveLayout="scroll">
              <Column field="id" header="Id"></Column>
              <Column field="" header="Project" body={projectBodyTemplate} style={{ minWidth: "15rem" }}></Column>
              <Column field="categoryId" header="Category" style={{ minWidth: "10rem" }} body={categoryBodyTemplate}></Column>
              <Column field="activityId" header="Activity" style={{ minWidth: "10rem" }} body={activityBodyTemplate}></Column>
              <Column header="Billing Type" body={ChargeableOrNot} style={{ minWidth: "10rem" }}></Column>
              <Column field="" header="Hours" body={hoursRoundOffTemplate}></Column>
              <Column field="jiraTaskId" header="JIRA / Task ID" style={{ minWidth: "10rem" }}></Column>
              <Column field="description" header="Description" style={{ minWidth: "15rem" }}></Column>
            </DataTable>
          </Fieldset>
        </Dialog>
      </div>
    );
  };

  const fetchApproveTeamTimesheet = () => {
    let param = {};
    param.userId = userData.id;
    param.status = "APPROVED";
    param.startDate = "";
    param.endDate = "";
    timesheetApi.getApprovedTeamTimesheet(param).then((resp) => {
      try {
        setApproveTeamTimesheet(resp.data.data);
        setDateRange(null);
      } catch (error) {
        // Error handle
      }
    });
  };

  const hoursRoundOff = (item) => {
    return item.totalHours?.toFixed(2);
  };

  return (
    <>
      <div className='grid mb-2'>
        <div className='col-12 mb-1 text-right'>
          <Calendar id="range" value={dateRange} onChange={(e) => dateRangeCalendar(e)} selectionMode="range" readOnlyInput dateFormat="dd-mm-yy" mask="99-99-9999" showIcon placeholder="Select date range" />
        </div>
      </div>
      <div className="datatable-style-demo">
        <DataTable
          paginator responsiveLayout="scroll" columnResizeMode="fit" scrollable="horizontal" rows={10} rowsPerPageOptions={[10, 20, 50]} dataKey="id" stripedRows ref={dt} value={approvedTeamTimesheet}
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" rowClassName={rowClassPopup}>
          <Column field="id" header="ID" style={{ minWidth: "8rem" }}></Column>
          <Column field="date" header="Date" style={{ minWidth: "10rem" }}></Column>
          <Column field="" header="Projects" style={{ minWidth: "10rem" }} body={projectListBodyTemplate}></Column>
          <Column field="" header="Total Hours" body={hoursRoundOff} style={{ minWidth: "8rem" }}></Column>
          <Column field="" header="Action" body={approvedActionBodyTemplate} style={{ minWidth: "10rem" }}></Column>
        </DataTable>
      </div>
      {ApprovedManagerViewTemplate()}
    </>
  );
};

export default ApprovedTeamTimesheet;